/**
 * 常用scheme列表
 */
var SCHEMES = {
    'com.tencent.mtt': 'mttbrowser://url=qb://home',
    'com.tencent.reading': 'qnreading://tab_reading?tab=kuaibao',
    'com.tencent.weishi': 'weishi://main?goto=recommend',
    'sogou.mobile.explorer': 'mttbrowser-sme://url=qb://tab/home',
    'com.sogou.reader.free': 'mttbrowser-sr://url=qb://tab/feedschannel?component=FeedsNovelPage&module=novelsingletab',
};
/**
 * 根据包名创建deeplink
 */
export var createDeeplink = function (packagename) {
    return SCHEMES[packagename] || 'mttbrowser://url=qb://home';
};
